import React from 'react';
import { LeftMenuItem } from '../shared/LeftMenuItem';
import { NotificationFlagsCategories } from '../../../../models/NotificationFlags/NotificationFlagsCategories';
import { paths } from '../../../../routing/path';

export const DataRequestMenuItem = () => (
    <LeftMenuItem
        icon="pe-7s-share"
        label="Data Request"
        to={paths.venues.grow.dataRequestDashboardOthers}
        flagCode={NotificationFlagsCategories.OtherDataRequests}
        trackingAction="Data Request"
        gtmCategory="Data Request"
    />
);
